import { Card } from '../../elements/ui/card';
import { Skeleton } from '../../elements/ui/skeleton';

/** Bar heights for the placeholder chart. Fixed rather than random so the skeleton never flickers on re-render. */
const BAR_HEIGHTS = [55, 75, 45, 85, 65, 90, 50, 70, 80, 60];

/**
 * Mirrors DashboardAnimalCard line for line - same paddings, same chart height, same footer strip - so the
 * grid does not jump when the dashboard data lands.
 */
export default function DashboardAnimalCardSkeleton() {
  return (
    <Card className="flex h-full flex-col">
      <div className="flex items-start justify-between gap-3 p-4">
        <div className="flex min-w-0 items-center gap-3">
          <Skeleton className="h-10 w-10 shrink-0 rounded-full" />
          <Skeleton className="h-4 w-20" />
        </div>

        <div className="flex shrink-0 flex-col items-end">
          <Skeleton className="h-3 w-16" />
          <Skeleton className="mt-1.5 h-7 w-10" />
        </div>
      </div>

      <div className="flex h-36 w-full items-end gap-2 px-4 pb-6">
        {BAR_HEIGHTS.map((height, index) => (
          <Skeleton key={index} className="flex-1 rounded-t-sm rounded-b-none" style={{ height: `${height}%` }} />
        ))}
      </div>

      <div className="flex flex-wrap gap-2 px-4 pt-3 pb-4">
        <Skeleton className="h-3 w-16" />
        <Skeleton className="h-3 w-14" />
        <Skeleton className="h-3 w-12" />
      </div>

      <div className="mt-auto border-t border-gray-100 px-4 py-3">
        <Skeleton className="mx-auto h-4 w-44" />
      </div>
    </Card>
  );
}
